<template>
  <div>
    <!-- Controls only visible when editing, hidden in print -->
    <div v-if="selectedDeck" class="no-print text-center mb-3">
      <button class="btn btn-primary me-2" @click="downloadCardImages">
        Download Card Images
      </button>
      <button class="btn btn-secondary" @click="printDeck">
        Print Deck
      </button>
    </div>

    <!-- Print layout -->
    <div v-if="selectedDeck" class="print-component">
      <div class="row">
        <div
          class="col-auto"
          v-for="(card, index) in cardsToDisplay"
          :key="index"
        >
          <CardDetailComponent :card="card" />
        </div>
      </div>
    </div>

    <!-- Fallback when no deck is selected -->
    <div v-else class="text-center text-muted">
      <p>No deck selected for printing.</p>
    </div>
  </div>
</template>

<script>
import { inject, ref, watch, nextTick } from "vue";
import html2canvas from "html2canvas";
import { GetCardForView } from "../services/CardAdapterService";
import CardDetailComponent from "./CardDetailComponent.vue";

export default {
  name: "PrintComponent",
  components: { CardDetailComponent },
  setup() {
    const selectedDeck = inject("selectedDeck");
    const cardsToDisplay = ref([]);

    // Generate extended cards list according to count
    const updateCards = async () => {
      if (!selectedDeck.value) {
        cardsToDisplay.value = [];
        return;
      }
      const result = [];
      for (const card of selectedDeck.value.cards) {
        const count = card.count || 1;
        for (let i = 0; i < count; i++) {
          const extended = await GetCardForView(card);
          result.push(extended);
        }
      }
      cardsToDisplay.value = result;
    };

    watch(
      () => selectedDeck.value && selectedDeck.value.cards,
      updateCards,
      { immediate: true, deep: true }
    );

    // Download each card as an image with "01x" prefix required for TTS
    const downloadCardImages = async () => {
      await nextTick();
      const elements = document.querySelectorAll(
        ".print-component .col-auto"
      );
      for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        const card = cardsToDisplay.value[i];
        if (!el) continue;
        const canvas = await html2canvas(el, { scale: 3, useCORS: true });
        const link = document.createElement("a");
        // TTS import expects 01x prefix for each card file
        link.download = `01x ${card.name}.png`;
        link.href = canvas.toDataURL("image/png", 1.0);
        link.click();
      }
    };

    // Trigger browser print dialog
    const printDeck = () => {
      window.print();
    };

    return {
      selectedDeck,
      cardsToDisplay,
      downloadCardImages,
      printDeck,
    };
  },
};
</script>
